import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { Modal, Spin, Timeline } from 'antd';
import { ISynclogHistory } from './types';
import './index.css';
import { useEffect, useState } from 'react';
import synclogService from '../../../../client-lib/api/synclog-service';
import { toastText } from '../../../../components/global/toast';
type Props = {
    open: boolean;
    onCancel: (isEdit?: boolean) => void;
    synclogId: string;
};

export const SynclogHistoryModal = ({ open, onCancel, synclogId }: Props) => {
    const [loading, setLoading] = useState(false);
    const [syncHistory, setSyncHistory] = useState<ISynclogHistory[]>([]);
    useEffect(() => {
        if (open && synclogId && synclogId.trim() !== '') {
            fetchSyncHistory();
        } else if (open && (!synclogId || synclogId.trim() === '')) {
            console.warn('Modal opened without valid synclogId:', synclogId);
            setSyncHistory([]);
            setLoading(false);
        }
    }, [open, synclogId]);

    const fetchSyncHistory = async () => {
        // Guard clause for missing / blank ID
        if (!synclogId?.trim()) {
            console.warn('fetchSyncHistory called without valid synclogId');
            setSyncHistory([]);
            return;
        }

        setLoading(true);
        try {
            const { result } = await synclogService.getB2BSynclogById(synclogId);

            const rawHistory = result?.history ?? null;

            const history = Array.isArray(rawHistory)
                ? rawHistory
                : rawHistory !== null
                    ? [rawHistory]            
                    : [];                     

            setSyncHistory(history);
        } catch (err: any) {
             const msg =
                err?.message ??
                err?.errorDescription ??
                (typeof err === 'string' ? err : 'Failed to fetch sync history');
            console.error(msg, err);
            toastText(msg, 'error');
            setSyncHistory([]);
        } finally {
            setLoading(false);
        }
    };


    const transformSyncHistory = (history: ISynclogHistory[]) => {
        console.log('history',
            history?.map((data: ISynclogHistory) => ({
                label: new Date(data.timeStamp).toLocaleString(),
                children: <p>{data.message}</p>,
                dot:
                    data.status === 'success' ? (
                        <CheckCircleOutlined
                            style={{ fontSize: '16px', color: 'green' }}
                        />
                    ) : data.status === 'pending' ? (
                        <InfoCircleOutlined
                            style={{ fontSize: '16px', color: 'orange' }}
                        />
                    ) : (
                        <CloseCircleOutlined
                            style={{ fontSize: '16px', color: 'red' }}
                        />
                    ),
            }))
        )
        return history?.map((data: ISynclogHistory) => ({
            label: new Date(data.timeStamp).toLocaleString(),
            children: <p>{data.message}</p>,
            dot:
                data.status === 'success' ? (
                    <CheckCircleOutlined
                        style={{ fontSize: '16px', color: 'green' }}
                    />
                ) : data.status === 'pending' ? (
                    <InfoCircleOutlined
                        style={{ fontSize: '16px', color: 'orange' }}
                    />
                ) : (
                    <CloseCircleOutlined
                        style={{ fontSize: '16px', color: 'red' }}
                    />
                ),
        }));
    };

    return (
        <Modal
            open={open}
            footer={null}
            width={800}
            onCancel={() => onCancel()}
            title={'Sync History'}
            centered
            className="sync-history-model"
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Spin size="large" />
                </div>
            ) : syncHistory.length > 0 ? (
                <Timeline
                    mode={'left'}
                    items={transformSyncHistory(syncHistory)}
                    className="syncHistoryItem"
                />
            ) : (
                <div style={{ textAlign: 'center', padding: '50px', color: '#999' }}>
                    <p>No sync history available for this record.</p>
                </div>
            )}
        </Modal>
    );
};
